import type { Challenge } from '@ai-platform/database';

import { ChallengeCard, ChallengeCardSkeleton } from '../../components/ChallengeCard';

export const renderSkeletonList = () => {
    return Array.from({ length: 8 }, (_, index) => <ChallengeCardSkeleton key={`challenge-skeleton-${index}`} />);
};

export const renderChallengeList = (data?: Challenge[]) => {
    return data?.map(challenge => <ChallengeCard key={challenge.id} challenge={challenge} />);
};
